'use strict';

var _ = require('lodash');
var PricingBarChartDirective = function PricingBarChartDirective(Chart) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/pricing-bar-chart.html'),
    controller: 'PricingBarChartController',
    scope: {
      datasetName: '@',
      chartState: '=',
      onExpandIconClick: '&',
      brushFilters: '=?',
      onUpdateBrushes: '=?',
      reactOnFilters: '=?'
    },
    link: function link(scope, element) {
      var chart = new Chart(element.find('.chart-container'), scope.chartFormatters);
      scope.renderChartDataPresent = function (data) {
        var chartWidth = scope.calculateChartWidth(data);
        chart.render(data, scope.selectedMetric, chartWidth);
      };
      scope.calculateChartWidth = function (data) {
        var spaceForChart = element.closest('div.rm-carousel').width() / 2 - 32;
        var barWidthSuggestion = (spaceForChart - (chart.padding.left + chart.padding.right)) / scope.MAX_BARS_AMOUNT;
        var barWidth = _.max([scope.BAR_MIN_WIDTH, barWidthSuggestion]);
        return barWidth * data.length;
      };
      chart.on('selectedBar', function (data, selectedIndex) {
        scope.data = _.transform(scope.data, function (result, data, index) {
          data.selected = index === selectedIndex;
          result.push(data);
        });
        scope.renderChartDataPresent(scope.data);
        scope.emitBrushFilter(data);
      });
    }
  };
};
PricingBarChartDirective.$inject = ['PricingBarChart'];
module.exports = PricingBarChartDirective;